var map = {
	"./ar/common.json": [
		88584,
		8584
	],
	"./ar/navbar.json": [
		7653,
		7653
	],
	"./cn/common.json": [
		40475,
		475
	],
	"./cn/navbar.json": [
		69512,
		9512
	],
	"./en/common.json": [
		90523,
		523
	],
	"./en/navbar.json": [
		14580,
		4580
	],
	"./fr/common.json": [
		37388,
		7388
	],
	"./fr/navbar.json": [
		2852,
		2852
	],
	"./kh/common.json": [
		15636,
		5636
	],
	"./kh/navbar.json": [
		17030,
		7030
	],
	"./lo/common.json": [
		75614,
		5614
	],
	"./lo/navbar.json": [
		97389,
		7389
	],
	"./th/common.json": [
		2950,
		2950
	],
	"./th/navbar.json": [
		43051,
		3051
	],
	"./vi/common.json": [
		37794,
		7794
	],
	"./vi/navbar.json": [
		69329,
		9329
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 51619;
module.exports = webpackAsyncContext;